import React from 'react';
import { ProcessingTag } from '../../ui/ProcessingTag';
import type { Service, ServiceStatus } from '../../../types/beheer';
export const SERVICE_TONE: Record<ServiceStatus, {
  dot: string;
  text: string;
}> = {
  gezond: {
    dot: 'bg-accent',
    text: 'text-ink-soft'
  },
  traag: {
    dot: 'bg-amber',
    text: 'text-amber'
  },
  slaapt: {
    dot: 'bg-white/25',
    text: 'text-ink-muted'
  },
  storing: {
    dot: 'bg-alarm',
    text: 'text-alarm'
  }
};
export function ServiceHealth({
  services
}: {
  services: (Service & {
    statusLabel?: string;
  })[];
}) {
  return <div className="no-scrollbar overflow-x-auto rounded-3xl border border-white/[0.07] bg-night-900" data-id="element-351" data-mp="1qfy01mqvwjyu">
      <table className="w-full min-w-[820px] text-left text-[14px]" data-id="element-352" data-mp="1lig0gmyrbh3i">
        <thead data-id="element-353" data-mp="1hhmcxup884b5">
          <tr className="border-b border-white/[0.06] text-[12px] text-ink-muted" data-id="element-354" data-mp="1hi5lwlwwfid1">
            <th scope="col" className="px-5 py-3 font-medium" data-id="element-355" data-mp="3fuw3zg064h4o">Dienst</th>
            <th scope="col" className="px-3 py-3 font-medium" data-id="element-356" data-mp="3bu2hmr2djadw">Status</th>
            <th scope="col" className="px-3 py-3 text-right font-medium" data-id="element-357" data-mp="3bsr9kf1wbggz">Latentie</th>
            <th scope="col" className="px-3 py-3 text-right font-medium" data-id="element-358" data-mp="34qgzsu6u8d8d">Uptime</th>
            <th scope="col" className="px-3 py-3 font-medium" data-id="element-359" data-mp="39os7ozdkodny">Host</th>
            <th scope="col" className="px-5 py-3 font-medium" data-id="element-360" data-mp="2vor7zn91nca2">Versie</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-white/[0.05]" data-id="element-361" data-mp="2zqcdgnj90oa8">
          {services.map(s => {
          const tone = SERVICE_TONE[s.status];
          return <tr key={s.id} data-id="element-362" data-mp="3sdp356kphc7r">
                <th scope="row" className="px-5 py-3 font-normal" data-id="element-363" data-mp="3scx4tnzq50ds">
                  <span className="block font-medium text-ink" data-id="element-364" data-mp="3emtp7fvco4xb">{s.name}</span>
                  <span className="block text-[12px] text-ink-muted" data-id="element-365" data-mp="3ekr1x3ll0pwa">{s.role}</span>
                </th>
                <td className="whitespace-nowrap px-3 py-3" data-id="element-366" data-mp="3ilss6uxitrm4">
                  <span className={`inline-flex items-center gap-2 ${tone.text}`} data-id="element-367" data-mp="a7k86b92e95k">
                    <span className={`h-2 w-2 rounded-full ${tone.dot}`} aria-hidden data-id="element-368" data-mp="f03tjudzu8kx" />
                    {s.statusLabel ?? s.status}
                  </span>
                </td>
                <td className="whitespace-nowrap px-3 py-3 text-right tabular-nums text-ink-soft" data-id="element-369" data-mp="ksxnwo74ivbo">
                  {s.latencyMs === null ? '—' : `${s.latencyMs} ms`}
                </td>
                <td className="whitespace-nowrap px-3 py-3 text-right tabular-nums text-ink-muted" data-id="element-370" data-mp="avjgtf73biw1">{s.uptime}</td>
                <td className="whitespace-nowrap px-3 py-3" data-id="element-371" data-mp="5wpztcslh9r4">
                  <span className="flex items-center gap-2 text-ink-muted" data-id="element-372" data-mp="5y17hnp5v1ni">
                    <code className="font-mono text-[12px]" data-id="element-373" data-mp="146q4qx12yrl">{s.host}</code>
                    {s.where === 'cloud' && <ProcessingTag where="cloud" data-id="element-374" data-mp="3t9injedv8c24" />}
                  </span>
                </td>
                <td className="whitespace-nowrap px-5 py-3 font-mono text-[12px] text-ink-muted" data-id="element-375" data-mp="3obqxyr0p1213">{s.version}</td>
              </tr>;
        })}
        </tbody>
      </table>
    </div>;
}